export class HierarchicalSearchService {
    filterItems(items, searchTerm) {
        if (!searchTerm) {
            this.makeAllItemsVisible(items);
            return;
        }
        items.forEach(item => {
            var _a;
            const titleMatches = (_a = item.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith(searchTerm.toLowerCase());
            if (titleMatches) {
                item.show();
                item.expand();
                this.makeAllItemsVisible(item.children());
                return;
            }
            if (titleMatches || this.hasMatchedChild(item.children(), searchTerm)) {
                item.show();
                item.expand();
            }
            else {
                item.hide();
            }
            this.filterItems(item.children(), searchTerm);
        });
    }
    makeAllItemsVisible(items) {
        items.forEach(item => {
            item.show();
            if (item.children().length) {
                this.makeAllItemsVisible(item.children());
            }
        });
    }
    hasMatchedChild(items, searchValue) {
        return items.some(item => {
            var _a;
            if ((_a = item.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith(searchValue.toLowerCase())) {
                return true;
            }
            return this.hasMatchedChild(item.children(), searchValue);
        });
    }
}
